module.exports = __webpack_public_path__ + "static/turquia-009.thumb-c353a46d79166a2de3bcf8a59b3b8efe.jpg";